import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1cbd6ff5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbd6ff5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbd6ff5')) {
      api.createRecord('1cbd6ff5', component.options)
    } else {
      api.reload('1cbd6ff5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1cbd6ff5&scoped=true&", function () {
      api.rerender('1cbd6ff5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/web/show/index.vue"
export default component.exports